import React, { useMemo } from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { AppRow } from '../../layout/appRow';
import { ColorPalette } from '../../styles/constants';
import { EmployeeAllocations } from '../../models/reports';
import { generateProjectLabel } from '../../services/projectService';
import { generateUserLabel } from '../../services/employeeService';

const styles = {
  paper: {
    m: 1,
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  name: {
    mb: 2,
    color: ColorPalette.RAISIN_BLACK,
    fontWeight: 700,
    size: '20px',
  },
  percenteage: {
    textUnderlineOffset: '3px',
    textDecoration: 'underline',
  },
  allocationContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  allocationText: {
    maxWidth: '90%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: 1,
  },
  totalLabel: { fontWeight: 700, color: ColorPalette.RAISIN_BLACK },
};

interface EmployeeAllocationsCardProps {
  employeeAllocations: EmployeeAllocations;
}

export function EmployeeAllocationsCard({
  employeeAllocations,
}: EmployeeAllocationsCardProps): JSX.Element {
  const allocationsData = useMemo(() => {
    let total = 0;

    const allocations = (
      <>
        {employeeAllocations.allocations.map((allocation) => {
          total += allocation.percentage;

          return (
            <AppRow key={`${allocation.project.id}`}>
              <Box sx={styles.allocationContainer}>
                <Typography sx={styles.allocationText}>
                  {generateProjectLabel(
                    allocation.project.name,
                    allocation.project.code
                  )}
                </Typography>

                <Typography
                  sx={styles.percenteage}
                >{`${allocation.percentage.toFixed(2)}%`}</Typography>
              </Box>
            </AppRow>
          );
        })}
      </>
    );

    return { allocations, total: `${total.toFixed(2)}%` };
  }, [employeeAllocations]);

  return (
    <Paper sx={styles.paper}>
      <Typography sx={styles.name}>
        {generateUserLabel(employeeAllocations.employee.name, employeeAllocations.employee.internalId, employeeAllocations.employee.employeeType)}
      </Typography>
      {allocationsData?.allocations}

      <AppRow sx={{ mt: 2 }}>
        <Typography sx={styles.allocationContainer}>
          <span style={styles.totalLabel}>Total:</span>
          <span style={{ ...styles.percenteage, color: ColorPalette.GREEN }}>
            {allocationsData.total}
          </span>
        </Typography>
      </AppRow>
    </Paper>
  );
}
